const styles = theme => ({
  root: {

  },
  navButtons: {
    alignItems: 'center',
    textAlign: 'center',
    margin: 20,
  },
  button: {
   marginLeft: 30,
   marginRight:30
 },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/components/CoreLayout/styles.js